interface StatsCardProps {
  label: string;
  value: number | string;
  color?: string;
  active?: boolean;
}

export function StatsCard({ label, value, color = '#2196F3', active = false }: StatsCardProps) {
  return (
    <div style={{
      background: active ? color : '#fff',
      borderRadius: active ? '8px 8px 0 0' : 8,
      padding: '10px 12px',
      boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
      borderLeft: `4px solid ${color}`,
      transition: 'background 0.15s',
      userSelect: 'none',
    }}>
      <div style={{ fontSize: 24, fontWeight: 700, color: active ? '#fff' : color }}>{value}</div>
      <div style={{ fontSize: 11, color: active ? 'rgba(255,255,255,0.85)' : '#757575', marginTop: 1, textTransform: 'uppercase', letterSpacing: 0.4 }}>
        {label}
      </div>
    </div>
  );
}
